import type { ReactNode } from 'react';

// SimShell is the shared card chrome for the K3 help simulations: a small
// header with a step counter and a title, wrapping a hand-authored frame.
// Frames are drawings of the UI, not re-mounts of real pages, so they stay
// within the K0.7 size budget and use design tokens only.
export function SimShell({
  step,
  total,
  title,
  children,
}: {
  step: number;
  total: number;
  title: string;
  children: ReactNode;
}): JSX.Element {
  return (
    <div className="rounded-md border border-dash-border bg-dash-bg p-3">
      <div className="flex items-center justify-between mb-2">
        <div className="text-[10px] font-mono uppercase tracking-wide text-dash-muted">
          Step {step} of {total}
        </div>
        <div className="text-[11px] font-mono text-dash-secondary">{title}</div>
      </div>
      {children}
    </div>
  );
}
